import { useContext, useEffect, useRef, useState } from "react";
import "./NotificationAlert.css";
import audio from "../../Assets/sounds/newNotification.mp3";
import { NotificationContext } from "../../Contexts/NotificationContext/NotificationContext";
import { t } from "i18next";
import { FaBell, FaTimes } from "react-icons/fa";

const imageB64URL =
  "data:image/webp;base64,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";

export const NotificationAlert = () => {
  const ifInteract = useRef(false);

  const { notifications, activeNotifications, notificationSoundOption, pushNotificationOption } = useContext(NotificationContext);

  const [ push, setPush ] = useState(false);
  const [ notificationConf, setNotificationConf ] = useState({});

  let { current: pushingNotifications } = useRef([]);

  const pushAlert = async conf => {
    try {
      if (ifInteract.current && notificationSoundOption) new Audio(audio).play();
    } catch (error) {
      console.log(error);
    }

    if (pushNotificationOption) {
      if (activeNotifications) try {
        const notificationInfo = {
          body: conf.message,
          icon: imageB64URL
        }
        
        new Notification(conf.title, notificationInfo);
      } catch (error) {
        console.log(error);
      }
      setNotificationConf(conf);
      setPush(true);
      await new Promise((resolve) => setTimeout(() => resolve(), 3000));
      setPush(false);
      await new Promise((resolve) => setTimeout(() => resolve(), 500));
    }
  };

  const pushNotification = async notification => {
    const pendingNotificationsToPush = [ ...pushingNotifications ];
    
    const notificationPromise = new Promise(async (resolve, reject) => {
      await Promise.all(pendingNotificationsToPush);

      await pushAlert(notification);
      resolve(true);
    });

    pushingNotifications.push(notificationPromise);
  }

  const knowedNotifications = useRef([]);
  const initPush = useRef(false);

  useEffect(() => {
    window.addEventListener("click", () => {
      ifInteract.current = true;
    });
  }, []);

  useEffect(() => {
    if (
      !initPush.current &&
      notifications.some(
        (notification) =>
          !notification.seen
      )
    ) {
      initPush.current = true;
      knowedNotifications.current = [ ...knowedNotifications.current, ...notifications.filter(n => !n.seen).map(n => n._id) ];
      pushNotification({
        title: t("common.tienesnotificaciones"),
        message: `${notifications.filter((n) => !n.seen).length} ${t("common.notificacionesporrevisar")}`
      });
    }

    for (const notification of notifications) {
      if (knowedNotifications.current.includes(notification._id) || notification.seen) continue;
      pushNotification(notification);
      knowedNotifications.current.push(notification._id);
    }
  }, [ notifications ]);

  return (
    <div
      className={`push-notification-container ${
        push ? "pushing" : "not-pushing"
      }`}
    >
      <FaBell className="push-notification-icon" />
      <div className="push-notification-info">
        <h4 className="push-notification-title">
          {notificationConf.title || t('words.notificacion')}
        </h4>
        <span className="push-notification-text">
          {notificationConf.message || t('common.sindescripcion')}
        </span>
        <FaTimes className="push-notification-close-btn" onClick={() => setPush(false)} />
      </div>
    </div>
  );
};
